import HttpService from "./HttpService";
import { ISitecoreAsset } from "../../shared/models/SitecoreAsset";

class SiteCoreService {
  private static instance: SiteCoreService
  private httpService = HttpService.Instance;

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  public async getSiteCoreAsset(assetId: string): Promise<ISitecoreAsset | undefined> {
    const assets: ISitecoreAsset[] = await this.getAllSiteCoreAssets()
    return assets.find((a: ISitecoreAsset) => a.id === assetId);
  }

  public async getAllSiteCoreAssets(): Promise<ISitecoreAsset[]> {
    const response = await this.httpService.get(`${process.env.REACT_APP_API_URL}assetconfig`);
    if (response.ok) {
      return response.json();
    }
    return [];
  }
}

export default SiteCoreService;


// WEBPACK FOOTER //
// ./src/modules/core/services/SiteCoreService.tsx